<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-header pb-0">
                        <div class="d-flex align-items-center">
                            <p class="mb-0">Configuración de la Empresa</p>
                        </div>
                    </div>
                    <div class="card-body">
                        <div v-if="isLoading" class="text-center py-5">
                            <div class="spinner-border text-success" role="status">
                                <span class="visually-hidden">Cargando...</span>
                            </div>
                        </div>

                        <form v-else @submit.prevent="submitConfig">

                            <div class="row mb-4">
                                <div class="col-md-12 text-center">
                                    <div>
                                        <label class="form-control-label">Logo de la Empresa</label>
                                    </div>
                                    <div class="image-upload-area mx-auto" @click="uploadPhoto()">
                                        <img :src="config.logo_url || fileUpload" alt="Logo Empresa" class="img-thumbnail" style="max-width:200px; height: auto; display: block;" @error="handleImageError" />
                                        <input type="file" style="display: none !important;" ref="companyLogoFile" accept="image/jpeg, image/png" @change="onFileChange($event)">
                                    </div>
                                    <small class="text-muted d-block mt-1">Haz clic para subir o cambiar el logo.</small>
                                    <small v-if="submitted && v$.config.logo_url.$error" class="text-danger d-block">URL de logo requerida/inválida.</small>
                                </div>
                            </div>

                            <hr class="horizontal dark">
                            <p class="text-uppercase text-sm">Información Legal y Fiscal</p>
                            <div class="row">
                                <div class="col-md-6">
                                    <label class="form-control-label">Nombre Legal (Emisor)</label>
                                    <argon-input v-model="config.emitter_name" type="text" placeholder="Razón Social S.A. de C.V." />
                                    <small v-if="submitted && v$.config.emitter_name.$error" class="text-danger">Nombre legal requerido.</small>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-control-label">NIT / RUC (Emisor)</label>
                                    <argon-input v-model="config.emitter_nit" type="text" placeholder="Ej: 0614-xxxxxx-xxx-x" />
                                    <small v-if="submitted && v$.config.emitter_nit.$error" class="text-danger">NIT/RUC requerido.</small>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-control-label">Régimen Tributario</label>
                                    <select class="form-control" v-model="config.tax_regime">
                                        <option value="Régimen General">Régimen General</option>
                                        <option value="Régimen Simplificado">Régimen Simplificado</option>
                                    </select>
                                </div>
                               <div class="col-md-6">
                                    <label class="form-control-label">Formato de Factura Predeterminado</label>
                                    <select class="form-control" v-model.number="config.invoice_default_format">
                                        <option :value="1">1 - Formato Ticket (80mm / POS)</option>
                                        <option :value="2">2 - Formato Legible (Carta / Fiscal)</option>
                                        <option :value="3">3 - Preguntar Siempre (Al imprimir)</option>
                                    </select>
                                </div>
                            </div>

                            <hr class="horizontal dark">
                            <p class="text-uppercase text-sm">Moneda e Impuestos</p>
                            <div class="row">
                                <div class="col-md-4">
                                    <label class="form-control-label">Código Moneda (ISO 4217)</label>
                                    <argon-input v-model="config.currency_code" type="text" placeholder="USD" maxlength="3" />
                                    <small v-if="submitted && v$.config.currency_code.$error" class="text-danger">Código de moneda requerido (ej: USD).</small>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-control-label">Símbolo Moneda</label>
                                    <argon-input v-model="config.currency_symbol" type="text" placeholder="$" maxlength="5" />
                                </div>
                                <div class="col-md-4">
                                    <label class="form-control-label">Tasa de Impuesto Predeterminada (%)</label>
                                    <argon-input v-model.number="config.default_tax_rate" type="number" step="0.01" placeholder="0.13" />
                                    <small class="text-muted">Usar 0.XX (ej: 0.13 para 13%)</small>
                                </div>
                                <div class="col-md-4">
                                    <label class="form-control-label">Tasa de Retención Predeterminada (%)</label>
                                    <argon-input v-model.number="config.default_retention_rate" type="number" step="0.01" placeholder="0.10" />
                                </div>
                                <div class="col-md-4">
                                    <label class="form-control-label">Tasa de Retención Grandes Contribuyentes (%)</label>
                                    <argon-input v-model.number="config.default_major_contributors_rate" type="number" step="0.01" placeholder="0.01" />
                                </div>
                                <div class="col-md-4">
                                    <label class="form-control-label">Monto Base para Retención</label>
                                    <argon-input v-model.number="config.retention_amount" type="number" step="0.01" placeholder="100" />
                                </div>
                            </div>

                            <hr class="horizontal dark">
                            <p class="text-uppercase text-sm">Información de Contacto</p>
                            <div class="row">
                                <div class="col-md-6">
                                    <label class="form-control-label">Correo Electrónico</label>
                                    <argon-input v-model="config.email" type="email" placeholder="contacto@empresa.com" />
                                    <small v-if="submitted && v$.config.email.$error" class="text-danger">Correo inválido.</small>
                                </div>
                                <div class="col-md-6">
                                    <label class="form-control-label">Teléfono</label>
                                    <argon-input v-model="config.phone_number" type="text" placeholder="+503 1234-5678" />
                                </div>
                                <div class="col-md-6">
                                    <label class="form-control-label">Página Web</label>
                                    <argon-input v-model="config.website" type="url" placeholder="https://www.empresa.com" />
                                </div>
                                <div class="col-md-6">
                                    <label class="form-control-label">País</label>
                                    <argon-input v-model="config.country" type="text" placeholder="El Salvador" />
                                </div>
                                <div class="col-md-6">
                                    <label class="form-control-label">Ciudad</label>
                                    <argon-input v-model="config.city" type="text" />
                                </div>
                                <div class="col-md-12">
                                    <label class="form-control-label">Dirección Fiscal</label>
                                    <argon-textarea v-model="config.address" rows="2" placeholder="Dirección completa..." />
                                </div>
                            </div>

                            <hr class="horizontal dark">
                            <p class="text-uppercase text-sm">Notas de Factura</p>
                            <div class="row">
                                <div class="col-md-12">
                                    <label class="form-control-label">Notas al pie de página de la factura</label>
                                    <argon-textarea v-model.number="config.footer_notes" rows="3" placeholder="Ej: Gracias por su preferencia. Documento sin validez fiscal." />
                                </div>
                            </div>
                            <hr class="horizontal dark">
                            <p class="text-uppercase text-sm">Configuración de Facturación Electrónica (DTE)</p>
                            <div class="row">

                                <div class="col-md-12 mb-3">
                                    <label class="form-control-label me-3">Habilitar Transmisión DTE:</label>
                                    <input
                                        type="checkbox"
                                        id="send_dte_toggle"
                                        v-model="config.send_dte"
                                        :true-value="1"
                                        :false-value="0"
                                    >
                                    <label for="send_dte_toggle" class="ms-2 text-sm">{{ config.send_dte == 1 ? 'Activo' : 'Inactivo' }}</label>
                                    <small class="d-block text-muted">Marque para intentar enviar cada factura a la DGII.</small>
                                </div>

                                <div class="col-md-6" v-if="config.send_dte==1">
                                    <label class="form-control-label">Client ID
                                    </label>
                                    <argon-input v-model="config.dte_client_id" type="text" placeholder="8H9432KHTWh$" />
                                    <small class="text-muted">Proporcionado por Hacienda para autenticación.</small>
                                </div>

                                <div class="col-md-6" v-if="config.send_dte==1">
                                    <label class="form-control-label">Contraseña</label>
                                    <argon-input v-model="config.dte_client_secret" type="password" placeholder="bL2811$VCLsE" />
                                    <small class="text-muted">Proporcionado por Hacienda para autenticación.</small>
                                </div>

                                <!-- <div class="col-md-6" v-if="config.send_dte==1">
                                    <label class="form-control-label">Contraseña del Certificado (.KEY)</label>
                                    <argon-input v-model="config.dte_cert_password" type="password" placeholder="bL2896$VKLtE" />
                                    <small class="text-muted">Contraseña para abrir el archivo de firma (.key).</small>
                                </div>

                                <div class="col-md-6" v-if="config.send_dte==1">
                                    <label class="form-control-label">Ruta/Nombre del Certificado (.KEY)</label>
                                    <argon-input v-model="config.dte_cert_path" type="text" placeholder="my_private_key.key" />
                                    <small class="text-muted">Nombre del archivo en la carpeta /certs/ del servidor.</small>
                                </div> -->
                                <div class="col-md-6" v-if="config.send_dte==1">
                                    <label class="form-control-label">Ambiente</label>
                                    <select class="form-control" v-model="config.dte_env">
                                        <option value="00">PRUEBAS</option>
                                        <option value="01">PRODUCCIÓN</option>
                                    </select>
                                    <small class="text-muted">Nombre del archivo en la carpeta /certs/ del servidor.</small>
                                </div>
                            </div>
                            <argon-button
                                type="submit"
                                class="mt-4"
                                color="success"
                                fullWidth
                                size="lg"
                            >
                                Actualizar Configuración
                            </argon-button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonTextarea from "@/components/ArgonTextarea.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import { useVuelidate } from '@vuelidate/core';
import { required, email, url, helpers } from '@vuelidate/validators';
import axios from "axios";
import Swal from 'sweetalert2';
import fileUpload from '@/assets/img/uploadfile.jpg'; // Placeholder

export default {
    name: "CompanyConfigForm",
    components: { ArgonInput,ArgonTextarea, ArgonButton },
    setup: () => ({ v$: useVuelidate() }),
    data() {
        return {
            fileUpload,
            submitted: false,
            isLoading: true,
            formats:[],
            config: {
                id: null, // Se llenará al cargar
                emitter_name: '',
                emitter_nit: '',
                tax_regime: 'Régimen General',
                currency_code: 'USD',
                currency_symbol: '$',
                default_tax_rate: 0.13,
                default_retention_rate:0.10,
                default_major_contributors_rate:0.01,
                retention_amount:100,
                address: '',
                city: '',
                country: 'El Salvador',
                phone_number: '',
                email: '',
                website: '',
                footer_notes: '',
                invoice_default_format:1,
                send_dte:0,
                dte_client_id:"",
                dte_client_secret:"",
                dte_cert_password:"",
                dte_cert_path:"",
                logo_url: null,
                dte_env:""
            }
        };
    },
    validations() {
        return {
            config: {
                emitter_name: { required: helpers.withMessage('Nombre legal es requerido', required) },
                emitter_nit: { required: helpers.withMessage('NIT es requerido', required) },
                currency_code: { required: helpers.withMessage('Código de moneda es requerido', required) },
                email: { email: helpers.withMessage('Correo electrónico inválido', email) },
                website: { url: helpers.withMessage('Debe ser una URL válida', url) },
                logo_url: { url: helpers.withMessage('Debe ser una URL válida', (value) => !value || /^https?:\/\/.+/.test(value)) },
            }
        };
    },
    mounted() {
        this.fetchConfig();
    },
    methods: {
        // === Lógica de Carga de Archivos (Logo) ===
        uploadPhoto() {
            this.$refs.companyLogoFile.click();
        },
        onFileChange(event) {
            const file = event.target.files[0];
            if (!file) return;

            const self = this;
            let formData = new FormData();
            formData.append('file', file);
            formData.append('fileName', file.name);
            //const token = localStorage.getItem("accessToken");

            // 🛑 Replicando la llamada Axios a tu servicio de archivos 🛑
            axios.post(this.$store.state.fileURL, formData,
                {
                headers: {
                    "Authorization": "Basic cHJpdmF0ZV9XVXVROG1DQncxV210WHc1empIa3NGQkNZQ1E9Og==",
                    'Content-Type': 'multipart/form-data'
                }
            }).then(function(result){
                self.config.logo_url = result.data.url;
                Swal.fire('Subida exitosa', 'El logo fue cargado.', 'success');
            }).catch(err => {
                console.error("Error al subir archivo:", err.response || err);
                Swal.fire('Error', 'Fallo al subir el logo.', 'error');
                self.config.logo_url = null;
            });
        },
        handleImageError(event) {
            event.target.src = this.fileUpload;
        },
        // ===========================================

        async fetchConfig() {
            this.isLoading = true;
            const token = localStorage.getItem("accessToken");
            const config = { headers: { 'Authorization': `Bearer ${token}` } };

            // Asumimos que la API permite obtener la configuración con un endpoint simple
            // o usando el ID de la compañía (si aplica), o asumiendo el ID 1.
            try {
                // Endpoint para obtener la configuración (asumo /company_config/1 o similar)
                const response = await axios.get(this.$store.state.apiURL + 'company_config?id='+localStorage.getItem('companyId'), config);

                // Si la API devuelve un array, toma el primer elemento. Si no hay, usa valores por defecto.
                const data = Array.isArray(response.data) && response.data.length > 0 ? response.data[0] : this.config;

                this.config = {
                    ...this.config,
                    ...data,
                    // Asegurar tipos de datos correctos
                    default_tax_rate: parseFloat(data.default_tax_rate) || 0.13,
                    id: data.id || null
                };

            } catch (error) {
                console.error("Error al cargar la configuración:", error.response || error);
                Swal.fire('Error', 'No se pudo cargar la configuración de la empresa.', 'error');
                // Mantener los valores por defecto si falla la carga
            } finally {
                this.isLoading = false;
            }
        },

        async submitConfig() {
            this.submitted = true;
            this.v$.$touch();

            if (this.v$.$invalid) {
                Swal.fire({ title: 'Datos inválidos', text: 'Por favor, revisa los campos obligatorios.', icon: 'warning', confirmButtonColor: '#0b9257' });
                return;
            }

            const token = localStorage.getItem("accessToken");
            const apiURL = this.$store.state.apiURL;
            const configId = this.config.id || 1; // Usamos el ID cargado o asumimos ID 1
            const method = this.config.id ? 'put' : 'post'; // Usar POST si no existe (crear), PUT si existe (actualizar)

            const reqConfig = { headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` } };

            try {
                let response;
                if (method === 'put') {
                    // Actualizar (PUT/PATCH) el registro existente
                    response = await axios.put(`${apiURL}company_config/${configId}`, this.config, reqConfig);
                } else {
                    // Crear un nuevo registro si no existía
                    response = await axios.post(`${apiURL}company_config`, this.config, reqConfig);
                }

                // Si la creación fue exitosa, actualiza el ID local
                if (method === 'post' && response.data.id) {
                    this.config.id = response.data.id;
                }

                Swal.fire({
                    title: 'Guardado',
                    text: 'La configuración fue actualizada correctamente.',
                    icon: 'success',
                    confirmButtonColor: '#0b9257'
                });

            } catch (err) {
                console.error('Error al guardar configuración:', err.response || err);
                const errorText = (err.response && err.response.data && err.response.data.error)
                                 ? err.response.data.error : 'Fallo al guardar la configuración.';
                Swal.fire({ title: 'Error', text: errorText, icon: 'error', confirmButtonColor: '#0b9257' });
            }
        },
    },
};
</script>

<style scoped>
.image-upload-area {
    cursor: pointer;
    border: 2px dashed #ccc;
    padding: 10px;
    margin-top: 10px;
    border-radius: 8px;
    display: inline-block;
}
.image-upload-area:hover {
    border-color: #5e72e4;
}
/* Estilo para que el selector de logo se centre */
.mx-auto {
    margin-left: auto !important;
    margin-right: auto !important;
}
</style>